import { render, staticRenderFns } from "./untermenu.vue?vue&type=template&id=00ced4a2&scoped=true&"
import script from "./untermenu.vue?vue&type=script&lang=js&"
export * from "./untermenu.vue?vue&type=script&lang=js&"
import style0 from "./untermenu.vue?vue&type=style&index=0&id=00ced4a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ced4a2",
  null
  
)

component.options.__file = "untermenu.vue"
export default component.exports